"use strict";import{html as h}from"@cisco-u/base";export function defaultLogo({height:C="100%",width:t=206,hidden:l=!1,title:i=""}={}){return h`<svg
    width=${t}
    height=${C}
    viewBox="0 0 206 109"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="${l?"true":"false"}"
    aria-label="${i}"
  >
    <path d="M67.3915 72.3676H58.2019V108.36H67.3915V72.3676Z" fill="white" />
    <path
      d="M140.139 82.3246C139.756 82.3246 136.693 80.4101 132.481 80.4101C126.737 80.4101 122.525 84.622 122.525 89.9826C122.525 95.3432 126.354 99.5551 132.481 99.5551C136.693 99.5551 139.756 98.0235 140.139 97.6406V107.213C138.99 107.596 135.927 108.362 131.715 108.362C121.377 108.362 112.57 101.47 112.57 89.9826C112.57 79.2614 120.611 71.6034 131.715 71.6034C135.927 71.6034 138.99 72.7521 140.139 72.7521V82.3246Z"
      fill="white"
    />
    <path
      d="M45.95 82.3245C45.5671 82.3245 42.5039 80.41 38.292 80.41C32.5484 80.41 28.3365 84.6219 28.3365 89.9825C28.3365 95.3431 32.1655 99.555 38.292 99.555C42.5039 99.555 45.5671 98.0234 45.95 97.6405V107.213C44.8013 107.596 41.7381 108.362 37.5262 108.362C27.1878 108.362 18.3811 101.47 18.3811 89.9825C18.3811 79.2613 26.422 71.6032 37.5262 71.6032C41.7381 71.6032 44.8013 72.7519 45.95 72.7519V82.3245Z"
      fill="white"
    />
    <path
      d="M168.852 80.793C163.491 80.793 159.662 85.0049 159.662 90.3655C159.662 95.7261 163.491 99.938 168.852 99.938C174.213 99.938 178.042 95.7261 178.042 90.3655C178.042 85.0049 174.213 80.793 168.852 80.793ZM187.614 89.9826C187.614 100.321 179.573 108.362 168.852 108.362C157.748 108.362 150.09 99.938 150.09 89.9826C150.09 79.6443 158.131 71.6034 168.852 71.6034C179.573 71.6034 187.614 80.0272 187.614 89.9826Z"
      fill="white"
    />
    <path
      d="M101.465 80.4101C101.465 80.4101 97.6361 79.2614 94.5729 79.2614C91.1268 79.2614 88.8294 80.4101 88.8294 82.3246C88.8294 84.622 91.5097 85.3878 93.0413 85.7707L95.7216 86.5365C101.465 88.451 104.145 92.28 104.145 96.8748C104.145 106.064 96.1045 108.745 89.2123 108.745C84.2345 108.745 80.0226 107.979 79.6397 107.596V99.5551C80.4055 99.5551 84.2345 100.704 88.0636 100.704C92.6584 100.704 94.5729 99.5551 94.5729 97.2577C94.5729 95.3432 92.6584 94.5774 90.361 93.8116C89.9781 93.8116 88.8294 93.4287 88.4465 93.0458C83.4687 91.5142 79.2568 88.451 79.2568 82.7075C79.2568 76.1982 84.2345 71.6034 92.6584 71.6034C97.2532 71.6034 101.082 72.7521 101.465 72.7521V80.4101Z"
      fill="white"
    />
    <path
      d="M8.80672 33.6954C8.80672 31.398 6.89222 29.1006 4.21191 29.1006C1.9145 29.1006 0 31.398 0 33.6954V43.268C0 45.9483 1.91451 47.8628 4.59481 47.8628C6.89222 47.8628 9.18962 45.9483 9.18962 43.268V33.6954H8.80672Z"
      fill="white"
    />
    <path
      d="M33.695 21.4417C33.695 19.1443 31.7805 16.8469 29.1002 16.8469C26.8028 16.8469 24.5054 18.7614 24.5054 21.4417V43.2671C24.5054 45.5645 26.4199 47.8619 29.1002 47.8619C31.3976 47.8619 33.695 45.9474 33.695 43.2671V21.4417Z"
      fill="white"
    />
    <path
      d="M58.2004 4.59481C58.2004 2.29741 56.2859 0 53.6056 0C51.3081 0 49.0107 1.91451 49.0107 4.59481V52.0745C49.0107 54.3719 50.9252 56.6693 53.6056 56.6693C55.903 56.6693 58.2004 54.7548 58.2004 52.0745V4.59481Z"
      fill="white"
    />
    <path
      d="M83.0895 21.4417C83.0895 19.1443 81.175 16.8469 78.4947 16.8469C75.8144 16.8469 73.8999 18.7614 73.8999 21.4417V43.267C73.8999 45.5644 75.8144 47.8618 78.4947 47.8618C81.175 47.8618 83.0895 45.9473 83.0895 43.267V21.4417Z"
      fill="white"
    />
    <path
      d="M107.595 33.6954C107.595 31.398 105.68 29.1006 103 29.1006C100.703 29.1006 98.4053 31.0151 98.4053 33.6954V43.2679C98.4053 45.9482 100.32 47.8627 103 47.8627C105.297 47.8627 107.595 45.9482 107.595 43.2679V33.6954Z"
      fill="white"
    />
    <path
      d="M132.101 21.4417C132.101 19.1443 130.186 16.8469 127.506 16.8469C125.208 16.8469 122.911 18.7614 122.911 21.4417V43.267C122.911 45.5644 124.825 47.8618 127.506 47.8618C129.803 47.8618 132.101 45.9473 132.101 43.267V21.4417Z"
      fill="white"
    />
    <path
      d="M156.989 4.59481C156.989 1.91451 155.075 0 152.394 0C150.097 0 147.8 1.91451 147.8 4.59481V52.0745C147.8 54.3719 149.714 56.6693 152.394 56.6693C154.692 56.6693 156.989 54.7548 156.989 52.0745V4.59481Z"
      fill="white"
    />
    <path
      d="M181.495 21.4417C181.495 19.1443 179.58 16.8469 176.9 16.8469C174.603 16.8469 172.305 18.7614 172.305 21.4417V43.2671C172.305 45.5645 174.22 47.8619 176.9 47.8619C179.58 47.8619 181.495 45.9474 181.495 43.2671V21.4417Z"
      fill="white"
    />
    <path
      d="M206 33.6954C206 31.398 204.085 29.1006 201.405 29.1006C199.108 29.1006 196.81 31.0151 196.81 33.6954V43.268C196.81 45.9483 198.725 47.8628 201.405 47.8628C203.703 47.8628 206 45.9483 206 43.268V33.6954Z"
      fill="white"
    />
  </svg>`}
//# sourceMappingURL=default-logo.js.map
